import getApi from '../../../api'
import { ApiErrorContent } from '../../../model/Error'
import { OrganizationInterop } from '../../../model/OrganizationInterop'
import { serializeOrganizationInteropUpdate } from './organizationInterop.mapper'

export const putOrganizationInterop = (
  organizationCode: string,
  organizationInterop: Partial<OrganizationInterop>,
) =>
  getApi().put<OrganizationInterop, ApiErrorContent>(
    `/admin/interop/organizations/${organizationCode}`,
    serializeOrganizationInteropUpdate(organizationInterop),
  )
